var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionTopRightRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 94,
    viewBox: "0 0 92 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.697 3.21638C28.7548 -2.56061 41.7045 3.64658 53.3984 8.02778C63.8478 11.9427 73.4146 17.3247 79.8012 26.4841C87.0143 36.8289 94.5554 49.3269 90.5173 61.2626C86.546 73.0008 72.1787 75.9936 61.1477 81.6192C50.7399 86.927 40.4024 95.9932 29.2392 92.5133C18.1605 89.0598 14.5856 75.8909 9.41436 65.4924C4.59758 55.8066 -0.554191 46.1866 0.871126 35.4698C2.53399 22.967 6.52944 9.05069 17.697 3.21638Z",
    fill: "#B2D7F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionTopRightRock);
export default __webpack_public_path__ + "static/media/heroSectionTopRightRock.ad71ead12e212ef815451dd412954152.svg";
export { ForwardRef as ReactComponent };